import { Component, ViewEncapsulation, Output, Input } from '@angular/core';
import { trigger, state, style, animate, transition, group } from '@angular/animations';
import { CfaTab } from '../cfa-tab';
import { Subject } from 'rxjs';
import { CfaMenuItem } from '../cfa-menu-item';

@Component({
       selector: 'cfa-bottom-tab-container',
    templateUrl: './bottom-tab-container.html',
    styleUrls: ['../../../styles/styles.scss', './bottom-tab-container.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('openOverlayState', [
            state('void', style({
                'pointer-events': 'none',
                opacity: 0,
                transform: 'scale(0.8)'
            })),
            transition('void => active', group([
                animate('100ms linear', style({ opacity: 1 })),
                animate('120ms cubic-bezier(0, 0, 0.2, 1)', style({ transform: 'scale(1)' })),
            ])),
            transition('active => void', animate('100ms 25ms linear', style({ opacity: 0 })))
        ])
    ],
    standalone: false
})
export class CfaBottomTabContainer {

    @Input() userName: string;
    @Input() showDropShadow = false;
    @Input() cfaTabs: CfaTab[] = [];
    @Input() cfaMenuItems: CfaTab[] = [];
    @Input() useMaterialTheme = false;

    @Output() signOutClicked = new Subject<void>();

    expandMenu = false;

    constructor() {
    }

    public closeExpandedPanes(skipCloseTabs?: boolean) {
        this.expandMenu = false;
        if (!skipCloseTabs) {
            this.closeExpandedTabs(null, true);
        }
    }

    closeExpandedTabs(tab?: CfaTab, skipClosePanes?: boolean) {
        this.cfaTabs.forEach(t => {
            if (!tab || t !== tab) {
                t.expanded = false;
            }
        });
        if (!skipClosePanes) {
            this.closeExpandedPanes(true);
        }
    }

    clickTab(event: Event, tab: CfaTab) {
        if (event.defaultPrevented) {
            return;
        }
        event.preventDefault();
        this.expandMenu = false;
        this.closeExpandedTabs(tab);
        if (tab.childTabs && tab.childTabs.length > 0) {
            tab.expanded = !tab.expanded;
        } else {
            tab.selected.next();
            this.closeExpandedTabs();
        }
    }

    selectMenuItem(menuItem: CfaMenuItem) {
        this.closeExpandedPanes();
        menuItem.selected.next();
    }

    clickSignOut() {
        this.closeExpandedPanes();
        this.signOutClicked.next();
    }

    clickMenu() {
        this.closeExpandedTabs();
        this.expandMenu = !this.expandMenu;
    }
}
